import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import Layout from './Layout'
import { Home } from './Views/Home'
import { Articles } from './Views/Articles'
import { Article } from './Views/Article'
import { PreviewShell } from './preview-shell'
import './index.css'

const router = createBrowserRouter([
  {
    element: <PreviewShell />,
    children: [
      {
        path: '/',
        element: <Layout withoutSidebarPadding />,
        children: [
          { index: true, element: <Home /> },
          { path: 'articles', element: <Articles /> },
          { path: 'articles/:slug', element: <Article /> },
        ],
      },
    ],
  },
])

createRoot(document.getElementById('root')!).render(<RouterProvider router={router} />)
